import React from 'react';
import { Shield, Layers, Wifi, Database, CheckCircle2 } from 'lucide-react';

const WhatIsSection = () => {
  const features = [
    {
      icon: Layers,
      title: "Sistema de Gestão Completo",
      description: "Plataforma integrada para gestão de frotas, passageiros e operação de transporte privado"
    },
    {
      icon: Shield,
      title: "Controle de Acesso Inteligente",
      description: "Gestão centralizada de autorizados com credenciais físicas e virtuais NFC+Bluetooth"
    },
    {
      icon: Wifi,
      title: "Rastreabilidade em Tempo Real",
      description: "Registro automático de todos os embarques e desembarques com geolocalização"
    },
    {
      icon: Database,
      title: "Dados Confiáveis",
      description: "Informações precisas para tomada de decisão estratégica e operacional"
    }
  ];

  return (
    <section id="what-is" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
          {/* Left - Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#007bff]/10 px-4 py-2 rounded-full border border-[#007bff]/20 mb-6">
              <Shield className="w-4 h-4 text-[#007bff]" />
              <span className="text-sm font-medium text-[#007bff]">O Sistema</span>
            </div>
            
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-['Sora']">
  O que é o{" "}
  <span className="font-extrabold">WCOM</span>
  <span className="font-normal">Pass</span>?
</h2>
            
            <p className="text-xl text-gray-600 leading-relaxed mb-8">
              O WCOMPass é uma <span className="font-semibold text-gray-900">plataforma completa de governança 
              operacional</span> para transporte corporativo, que vai além do rastreamento tradicional.
            </p>

            <div className="space-y-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="flex items-start gap-4 group">
                    <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-[#007bff]/10 flex items-center justify-center group-hover:bg-[#007bff] transition-colors duration-300">
                      <Icon className="w-6 h-6 text-[#007bff] group-hover:text-white transition-colors duration-300" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mt-10 p-6 bg-gradient-to-r from-[#008080]/10 to-[#007bff]/10 rounded-2xl border border-[#007bff]/20">
              <div className="flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-[#008080] flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-700">
                  <span className="font-bold text-gray-900">Diferencial exclusivo:</span> O WCOMPass 
                  adiciona uma camada de governança que agrega valor ao fretamento tradicional, 
                  transformando dados em decisões estratégicas.
                </p>
              </div>
            </div>
          </div>

          {/* Right - Visual */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://wcompass.com.br/img/dashboard.jpg" 
                alt="Dashboard WCOMPass"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f1a36] via-transparent to-transparent"></div>
              
              {/* Floating stats */}
              <div className="absolute bottom-8 left-8 right-8 grid grid-cols-3 gap-4">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center">
                  <p className="text-3xl font-bold text-[#007bff]">100%</p>
                  <p className="text-sm text-gray-700 font-medium">Rastreável</p>
                </div>
                <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center">
                  <p className="text-3xl font-bold text-[#008080]">24/7</p>
                  <p className="text-sm text-gray-700 font-medium">Tempo Real</p>
                </div>
                <div className="bg-white/90 backdrop-blur-sm rounded-xl p-4 text-center">
                  <p className="text-3xl font-bold text-[#007bff]">NFC</p>
                  <p className="text-sm text-gray-700 font-medium">Tecnologia</p>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-[#007bff] rounded-full opacity-10 blur-2xl"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-[#008080] rounded-full opacity-10 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsSection;
